/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const TwitterBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path d="M22 5.924a8.15 8.15 0 0 1-2.359.646 4.112 4.112 0 0 0 1.806-2.27c-.794.47-1.67.812-2.606.996a4.107 4.107 0 0 0-7.1 2.808c0 .32.041.634.112.934a11.645 11.645 0 0 1-8.459-4.287 4.093 4.093 0 0 0 1.27 5.478 4.076 4.076 0 0 1-1.858-.513v.052a4.103 4.103 0 0 0 3.288 4.023 4.075 4.075 0 0 1-1.853.07 4.113 4.113 0 0 0 3.835 2.85 8.245 8.245 0 0 1-5.1 1.757c-.329 0-.652-.02-.976-.057a11.613 11.613 0 0 0 6.288 1.843c7.547 0 11.677-6.252 11.677-11.675 0-.177-.006-.355-.012-.53A8.31 8.31 0 0 0 22 5.923Z" /></svg>);
const Twitter = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={TwitterBase} {...rest} ref={ref} />);
export default Twitter;